import React, { useState } from 'react';
import { LuBox, LuDollarSign, LuEye } from 'react-icons/lu';
import formatBRL from '../../../shared/utils/formatBRL';
import DetailModal from './DetailModal';
import './StockSummaryCard.css';

const COLUMNS = [
  { key: 'name', label: 'Produto' },
  { key: 'quantity', label: 'Qtd.', align: 'right' },
  { key: 'unitCost', label: 'Custo unit.', align: 'right', format: (v) => (v != null ? formatBRL(v) : '—') },
  { key: 'costValue', label: 'Valor de custo', align: 'right', format: (v) => formatBRL(v) },
  { key: 'saleValue', label: 'Valor de venda', align: 'right', format: (v) => formatBRL(v) },
];

// Estoque total + valor em estoque — sem gráfico (pedido explicitamente).
// O ícone de olho abre o modal com o comparativo custo x venda por produto,
// já ordenado do que tem mais estoque pro que tem menos (o backend já
// devolve nessa ordem).
const StockSummaryCard = ({ summary }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const totalQuantity = summary?.totalQuantity ?? 0;
  const totalCostValue = summary?.totalCostValue ?? 0;
  const totalSaleValue = summary?.totalSaleValue ?? 0;
  const products = summary?.products || [];
  const potentialProfit = totalSaleValue - totalCostValue;

  return (
    <div className="stock-summary-card">
      <div className="stock-summary-card__header">
        <h5 className="mb-0">Estoque</h5>
        <button
          type="button"
          className="dashboard-eye-btn"
          onClick={() => setModalOpen(true)}
          aria-label="Ver detalhes do estoque"
        >
          <LuEye size={18} />
        </button>
      </div>

      <div className="stock-summary-card__tiles">
        <div className="stock-summary-card__tile">
          <LuBox size={20} />
          <div>
            <span className="stock-summary-card__tile-label">Estoque total</span>
            <span className="stock-summary-card__tile-value">{totalQuantity} itens</span>
          </div>
        </div>
        <div className="stock-summary-card__tile">
          <LuDollarSign size={20} />
          <div>
            <span className="stock-summary-card__tile-label">Valor em estoque (venda)</span>
            <span className="stock-summary-card__tile-value">{formatBRL(totalSaleValue)}</span>
          </div>
        </div>
      </div>

      <div className="stock-summary-card__comparison">
        <span>Custo: <strong>{formatBRL(totalCostValue)}</strong></span>
        <span>Venda: <strong>{formatBRL(totalSaleValue)}</strong></span>
        <span>Lucro potencial: <strong>{formatBRL(potentialProfit)}</strong></span>
      </div>

      <DetailModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        title="Estoque por produto"
        columns={COLUMNS}
        rows={products}
      />
    </div>
  );
};

export default StockSummaryCard;
